import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { FaChevronDown } from "react-icons/fa";
import { MdClose, MdMenu, MdSettings } from "react-icons/md";
import { ImExit } from "react-icons/im";

function Nav({ signedIn, profileName, avatar }) {
  const [scrolledDown, setScrolledDown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isActive, setActive] = useState(false);
  const [isDown, setDown] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    setDown(false);
  };
  const menuCheck = () => {
    if (isOpen) {
      setTimeout(setIsOpen(false), 1500);
    }
  };
  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        console.log("Signed out successfully");
      })
      .catch((error) => {
        // An error happened.
        console.log(error);
      });
    window.location.reload();
  };
  const openMenu = () => {
    setActive(!isActive);
  };
  const closeMenu = () => {
    setActive(!isActive);
    setDown(false);
    setIsOpen(false);
  };
  const toggleDown = () => {
    setDown(!isDown);
    setIsOpen(false);
  };
  const getInitials = (data) => {
    let initial = [];
    let getNext = false;
    initial.push(data.charAt(0).toUpperCase());
    if (data.includes(" ")) {
      for (const letter of data) {
        if (letter === " ") {
          getNext = true;
        } else {
          if (getNext) {
            initial.push(letter.toUpperCase());
            getNext = false;
          } else {
            continue;
          }
        }
      }
    }
    return initial.join("");
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const isScrolledDown = scrollTop > 0;
      setScrolledDown(isScrolledDown);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header
      className={`flex justify-between align-center ${
        scrolledDown ? "down" : ""
      }`}
    >
      <Link to="/" className="logo flex align-center">
        <img
          src="https://res.cloudinary.com/qaz2dc/image/upload/v1690305332/ucbraids/ucbraid_kj4rp1.png"
          alt="UCBRAIDS"
        />
        {/* <h3>UC Braids</h3> */}
      </Link>
      <nav
        className={`flex justify-center align-center ${
          isActive ? "mobileOpen" : ""
        }`}
      >
        <ul>
          <li onClick={closeMenu}>
            <Link to="/">
              Home
              <div className="line"></div>
            </Link>
          </li>
          <li onClick={closeMenu}>
            <Link to="/about">
              About
              <div className="line"></div>
            </Link>
          </li>
          <li onClick={toggleDown}>
            <Link>
              Services
              <div className="line"></div>
            </Link>
            <ol className={isDown ? "down" : ""}>
              <li onClick={closeMenu}>
                <Link to="/services/small">Small</Link>
              </li>
              <li onClick={closeMenu}>
                <Link to="/services/medium">Medium</Link>
              </li>
              <li onClick={closeMenu}>
                <Link to="/services/large">Large</Link>
              </li>
              <li onClick={closeMenu}>
                <Link to="/services/tribal-braids">Tribal Braid</Link>
              </li>
              <li onClick={closeMenu}>
                <Link to="/services/men">Men</Link>
              </li>
              <li onClick={closeMenu}>
                <Link to="/services/kids">Kids</Link>
              </li>
              <li onClick={closeMenu}>
                <Link to="/services/locs">Locs</Link>
              </li>
              <li onClick={closeMenu}>
                <Link to="/services/miscellaneous">Miscellaneous</Link>
              </li>
            </ol>
          </li>
          <li onClick={closeMenu}>
            <Link to="/contact">
              Contact
              <div className="line"></div>
            </Link>
          </li>
        </ul>
        {signedIn ? (
          <div className="profile">
            <div className="avatar flex align-center">
              <div className="circle">
                {avatar ? (
                  <img src={avatar} alt="Avatar" />
                ) : (
                  <p>{getInitials(profileName)}</p>
                )}
              </div>

              <FaChevronDown onClick={toggleMenu} />
            </div>
            <div
              className={`dropdown ${isOpen ? "open" : ""}`}
              onClick={menuCheck}
            >
              <p>Hi, {profileName}</p>
              <Link
                to="/settings"
                className="flex align-center justify-center"
                onClick={closeMenu}
              >
                <MdSettings />
                Account Settings
              </Link>
              <button className="button" onClick={handleLogout}>
                <ImExit />
                Log Out
              </button>
            </div>
          </div>
        ) : (
          <div className="buttons flex align-center justify-center">
            <Link
              to="/login"
              className="button button-primary"
              onClick={closeMenu}
            >
              Log In
            </Link>
            <Link
              to="/signup"
              className="button button-secondary"
              onClick={closeMenu}
            >
              Sign Up
            </Link>
          </div>
        )}
      </nav>
      {isActive ? (
        <MdClose className="close" onClick={closeMenu} />
      ) : (
        <MdMenu className="burger" onClick={openMenu} />
      )}
    </header>
  );
}

export default Nav;
